import { ResultsCount } from '@mi-front/ui';
import { FormattedMessage, useIntl } from 'react-intl';
import { UploadState } from '../../types';
import { NoFilesSelected } from './NoFilesSelected';
import { UploadActions } from './UploadActions';
import { UploadItem } from './UploadItem';

interface Props {
  readonly uploads: readonly UploadState[];
  readonly add: null | ((files: readonly File[]) => void);
  readonly clearAll: null | (() => void);
  readonly upload: null | (() => Promise<void>);
  readonly remove: (index: number) => void;
  readonly updateId: (index: number, value: string) => void;
}

export function UploadViewP(p: Props) {
  const { $t } = useIntl();

  return (
    <div>
      {p.uploads.length ? (
        <div className="mb-3">
          <ResultsCount count={p.uploads.length}>
            <FormattedMessage
              id="audit.uploadScreen.selectedCount"
              defaultMessage={`
        {count, plural,
          one {1 archivo seleccionado}
          other {# archivos seleccionados}
        }
      `}
              values={{ count: p.uploads.length }}
            />
          </ResultsCount>
          {p.uploads.length > 2 && (
            <div className="mb-3">
              <UploadActions upload={p.upload} clearAll={p.clearAll} />
            </div>
          )}
          {p.uploads.map((upload, index) => (
            <UploadItem
              index={index}
              upload={upload}
              key={index}
              remove={() => p.remove(index)}
              updateId={(value) => p.updateId(index, value)}
            />
          ))}
        </div>
      ) : (
        p.add && <NoFilesSelected onChange={(files) => files && p.add!(files)} />
      )}
      <UploadActions upload={p.upload} clearAll={p.clearAll} />
    </div>
  );
}
